function sentinelTableSortHeader(filterService) {
    return {
        restrict: 'E',
        scope: {
            fieldTitle: "@",
            fieldName: "@",
            tableTitle: "="
        },
		template: require('./table-sort-header.html'),

        link: function (scope) {
            scope.displayOptions = filterService.getTableDisplayOptions(scope.tableTitle);

            scope.sortByField = function(){
                if(scope.fieldName !== scope.displayOptions.sortField){
                    scope.displayOptions.sortDirection = 'desc';
                }else{
                    scope.displayOptions.sortDirection = scope.displayOptions.sortDirection === 'desc' ? 'asc' : 'desc';
                }

                scope.displayOptions.sortField = scope.fieldName;

                filterService.setTableDisplayOptions(scope.tableTitle, scope.displayOptions);
            };
        }
    };
}
angular.module('sentinel').directive('sentinelTableSortHeader', ['sentinelUiFilterService', sentinelTableSortHeader]);